import {useDispatch, useSelector} from "react-redux";
import Comment from "./Comment";
import {useEffect} from "react";
import {newsCommentsGet} from "../actions";
import CommentForm from "./CommentForm";
import LoadingIndicator from "./LoadingIndicator";

function CommentsContainer({ newsId }) {
  const comments = useSelector(state => state.comments[newsId]);

  const dispatch = useDispatch();
  useEffect(() => {
    if (!comments) {
      dispatch(newsCommentsGet({ id: newsId })).catch(() => {});
    }
  });

  return (
    <div>
      <div id={"comments"}>
        <LoadingIndicator isLoading={!comments || comments.loading} />
        {
          comments && comments.comments && comments.comments.map(comment => (
            <Comment comment={comment}  key={comment.id} />
          ))
        }
      </div>
      <CommentForm newsId={newsId} />
    </div>
  );
}

export default  CommentsContainer;